import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { http, formatError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email is registered, a reset link is on its way.");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-[80vh] flex items-center justify-center" data-testid="forgot-password-page">
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onSubmit={submit}
        className="glass-panel rounded-lg p-10 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="text-[10px] tracking-[0.35em] uppercase text-pink-blush mb-3">Forgot your password?</div>
          <h1 className="font-display text-4xl text-champagne">
            No trouble at all, <span className="italic text-pink-hot">darling</span>
          </h1>
          <p className="text-sm text-champagne/70 mt-4">
            Enter your email and I'll send you a link to reset your password.
          </p>
        </div>

        {sent ? (
          <div className="text-center">
            <p className="text-sm text-champagne/85 leading-relaxed mb-6">
              If <span className="text-pink-blush">{email}</span> is registered, a reset link will arrive shortly. The link is valid for one hour.
            </p>
            <Link to="/login" className="text-pink-hot pink-underline-link text-xs tracking-[0.28em] uppercase" data-testid="back-to-login">
              ← Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <input
              required
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne mb-3"
              data-testid="forgot-email"
            />
            <button
              disabled={loading}
              className="w-full py-3 bg-pink-hot text-white text-xs tracking-[0.3em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all disabled:opacity-60"
              data-testid="forgot-submit"
            >
              {loading ? "Sending..." : "Send reset link"}
            </button>
            <div className="divider-gold my-6" />
            <div className="text-center text-sm text-champagne/70">
              Remembered it?{" "}
              <Link to="/login" className="text-pink-hot pink-underline-link" data-testid="go-login">
                Sign in
              </Link>
            </div>
          </>
        )}
      </motion.form>
    </div>
  );
}
